// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__29yTX","inner":"Footer_inner__3ejc6"};